// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PressArticle__image___2WV1M{width:100%;height:330px;border-radius:8px;-o-object-fit:cover;object-fit:cover}.PressArticle__intro___xfGZ0{margin-top:80px}.PressArticle__intro___xfGZ0 *{color:#2c2302;font-size:20px;line-height:32px}.PressArticle__intro___xfGZ0 :not(:first-child){margin-top:16px}.PressArticle__body___1LtYw{margin-top:24px}.PressArticle__body___1LtYw h2{margin-top:40px;font-size:20px;line-height:32px}.PressArticle__summary___n6KCH{margin-top:24px;color:#6b6651}.PressArticle__cardList___3AkOS{display:flex;margin-top:80px}.PressArticle__card___2qajn{flex-grow:1;max-width:inherit;margin-right:40px}.PressArticle__card___2qajn:last-child{margin-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"image": "PressArticle__image___2WV1M",
	"intro": "PressArticle__intro___xfGZ0",
	"body": "PressArticle__body___1LtYw",
	"summary": "PressArticle__summary___n6KCH",
	"cardList": "PressArticle__cardList___3AkOS",
	"card": "PressArticle__card___2qajn"
};
module.exports = ___CSS_LOADER_EXPORT___;
